/**
 * Organization API endpoints
 */
import axiosClient from './axiosClient';

export interface Organization {
  id: string;
  name: string;
  description?: string;
  domain?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const organizationAPI = {
  /**
   * Get all organizations
   */
  getOrganizations: async (params?: {
    skip?: number;
    limit?: number;
  }): Promise<Organization[]> => {
    const response = await axiosClient.get<Organization[]>('/organizations', { params });
    return response.data;
  },

  /**
   * Get organization by ID
   */
  getOrganization: async (id: string): Promise<Organization> => {
    const response = await axiosClient.get<Organization>(`/organizations/${id}`);
    return response.data;
  },
};

